export default class APIRequestError {
    // this class is for errors in the request. API errors from the API should use APIResponseError as
    // invalid requests return 200 HTTP responses
    constructor (err) {
        this._message = err
    }

    message () {
        return this._message
    }

    success () {
        return false
    }
}



// WEBPACK FOOTER //
// ./src/models/responses/APIRequestError.js